var exports = {
  "my": "avatar__xEwydj",
  "kL": "container__naHVEn",
  "wx": "header__TrPer4",
  "NX": "topicName__-D5m5A",
  "Wi": "descriptionWrapper__ZcN-29",
  "h_": "description__BI03vR",
  "xF": "accentLink__vdAHzq",
  "oJ": "mutedLink__-fZO2P",
};

module.exports = exports;
